export default __webpack_public_path__ + "static/media/dummy-profile.aa496666.jpg";